<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-7">
            <div class="row pt-2 text-start mb-2">
                <div class="col-6">
                  <h5>
                    <span class="badge rounded-pill text-white p-2 px-3" style="background:LimeGreen">
                    <b>Promotion Package : จัดชุดโปรโมชั่นหรือจัดแพคเกจราคาพิเศษ</b>
                    </span>
                  </h5>
                </div>
                <div class="col-6">
                  <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#exampleModal" @click="newRecord()" style="width:150px;">New</button>
                </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-7">
          <div class="col-sm bg-light border py-2">
              <table id="myPropackTable" class="table table-hover display table-sm" style="width: 100%;">
                  <thead class="text-white" style="background:Navy">
                  <tr>
                      <th class="text-start" style="width:80px;">รหัสแพคเกจ</th>
                      <th class="text-start" style="width:200px;">ชื่อแพคเกจ</th>
                      <th class="text-center" style="width:80px;">เป็นห้องตรวจเสมือน</th>
                      <th class="text-start" style="width:10px;">ราคา</th>
                      <th style="width:80px;">คำสั่ง</th>
                  </tr>
                  </thead>
                  <tbody>
                      <tr v-for="item in datalists" :key="item.PropackID" class=""
                        v-bind:data-id="item.PropackID"  @click="tableChanged(item)">
                          <td class="text-start bg-info">{{ item.PropackCode }}</td>
                          <td class="text-start"><b>{{ item.PropackName }}</b></td>
                          <td class="text-center">
                            <span v-if="item.isMultiRoomProfile==1" :title="arrIsMultiRmProfile[item.isMultiRoomProfile]"><i class="fa fa-hospital-o"></i></span>
                          </td>
                          <td class="text-end">{{ numeralFormat(item.UnitPrice, '0,0[.]00') }}</td>
                          <td class="">
                              <button type="button" class="btn btn-primary btn-sm py-0 mx-1" id="Edit" data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</button>
                              <button class="btn btn-danger btn-sm py-0" id="Delete" @click="cancelRecord(item)">Del</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </div>
        <div class="col-sm">
          <div class="card"  style="background-color: GhostWhite;">
            <div class="card-body">
              <div class="d-grid">
                <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addTestsuitModal" @click="addTestRecord()">เพิ่มชุดตรวจลงในแพคเกจ</button>
              </div>
              <MPropack2Dtl :curRecord="curRecord" :key="countRefreshDtl"
                :dataTestsuitsLists="dataTestsuitsLists"
                @onRefreshDtlAfterUpdate="refreshDtlAfterUpdate"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <div id="exampleModal" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header" style="background-color:Gainsboro">
            <h5 class="modal-title">Promotion Packages | แพคเกจ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-start">
            <form id="fmTestsuit" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                <input type="text" hidden class="form-control" id="PropackID" placeholder="" name="PropackID" v-model="curRecord.PropackID" >
                <div class="row mb-2">
                    <div class="col-6">
                        <label for="code" class="mr-sm-2">รหัส/ชื่อ ชุดตรวจ* :</label>
                        <input type="text" class="form-control" id="code" placeholder="รหัสชุดตรวจ*" name="PropackCode" v-model="curRecord.PropackCode" autocomplete="off" required>
                    </div>
                    <div class="col-6">
                        <label class="mr-sm-2">ราคาขาย* :</label>
                        <input type="number" class="form-control" placeholder="ราคาขาย" name="UnitPrice" v-model="curRecord.UnitPrice" autocomplete="off" style="background:OldLace;">
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col">
                        <input type="text" class="form-control mb-2" id="PropackName"  placeholder="ชื่อชุดตรวจ*" name="PropackName" v-model="curRecord.PropackName" autocomplete="off" required>
                        <!-- <input type="text" class="form-control mb-2" id="TestName2"  placeholder="ชื่อชุดตรวจ (ไทย)*" name="TestName2" v-model="curRecord.TestName2" autocomplete="off" required> -->
                    </div>
                </div>

                <!-- เป็น แพคเกจปกติ หรือ เปลี่ยนเป็นเสมือนห้องตรวจ -->
                <div class="row">
                    <div class="col">
                        <label for="isMultiRoomProfile">รูปแบบแพคเกจ</label>
                        <select id="isMultiRoomProfile" class="form-control form-select" name="isMultiRoomProfile" v-model="curRecord.isMultiRoomProfile">
                            <option value="0">แพคเกจ</option>
                            <option value="1">เสมือนเป็นห้องตรวจ</option>
                        </select>
                    </div>
                </div>
            </form>
          </div>

          <div class="modal-footer" style="background-color:Gainsboro">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import MPropack2Dtl from './MPropack2Dtl.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'MPropack1View',
  data () {
    return {
      arrIsMultiRmProfile: ['', 'As Multi Room Profile'], // 0-แพคเกจ 1-เสมือนเป็นห้องตรวจ(รวมชุดตรวจจากหลายห้องได้)
      curRecord: {
        PropackID: 0,
        PropackName: ''
      },
      datalists: null,
      dataDtlLists: null,
      // ข้อมูล dailog รายการชุดตรวจ
      dataTestsuitsLists: null,

      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      countRefreshDtl: 0
    }
  },
  props: [],
  mounted () {
    this.getTestsuitsData()
    // รายการชุดตรวจทั้งหมด
    this.getData()
  },
  components: {
    MPropack2Dtl
  },
  methods: {
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.TestName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_propack.php',
            data: { id: item.PropackID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.refreshAfterUpdate()
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmTestsuit').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_propack.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            self.refreshAfterUpdate()
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    // Master Update : Refresh screen
    refreshAfterUpdate () {
      this.$emit('onRefreshAfterUpdate')
    },
    // หลังจาก เพิ่ม หรือ จัดลำดับ ชุดตรวจในแพคเกจ : Refresh Table ด้านขวา
    refreshDtlAfterUpdate () {
      this.countRefreshDtl++
    },
    // ดึงรายการชุดตรวจทั้งหมด (Testsuits) สำหรับให้เลือกเพื่อเพิ่มในแพคเกจ
    getTestsuitsData () {
      MyApiClient.get('getdata/testsuits_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.dataTestsuitsLists = resp.data.response
          // this.$nextTick(() => {
          //   $('#myAddTestsuitTable').DataTable()
          // })
          setTimeout(function () { $('#myAddTestsuitTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
      this.countRefreshDtl++
    },
    getData () {
      MyApiClient.get('getdata/propacks_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          this.$nextTick(() => {
            $('#myPropackTable').DataTable()
          })
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
